<template>
  <div class="main-box">
    <!-- 黑名单应用 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t("message.appDesktopMsg.BlacklistApp") }}
        </span>
      </el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle-app">{{ $t("message.appDesktopMsg.BlacklistInfo") }}:</span>
        <el-button type="text" @click="openBlackDialog">{{ $t("message.systemMsg.add") }}</el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box" v-if="blacklist.length > 0">
          <el-tag id="tag-box" v-for="(v, i) in blacklist" :key="i">{{
            v.packageName.length > 30
              ? v.packageName.substring(0, 29) + "..."
              : v.packageName
          }}</el-tag>
        </div>
      </el-col>
    </el-row>
    <!-- 不可卸载应用 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">
          {{ $t("message.appDesktopMsg.uninstallApp") }}
        </span>
      </el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle-app">{{ $t("message.appDesktopMsg.uninstallAppInfo") }}:</span>
        <el-button type="text" @click="openUninstallDialog">{{ $t("message.systemMsg.add") }}</el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box" v-if="uninstall.length > 0">
          <el-tag id="tag-box" v-for="(v, i) in uninstall" :key="i">{{
            v.packageName.length > 30
              ? v.packageName.substring(0, 29) + "..."
              : v.packageName
          }}</el-tag>
        </div>
      </el-col>
    </el-row>
    <!-- 保活应用 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t("message.appDesktopMsg.LiveApp") }}</span>
      </el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle-app">{{ $t("message.appDesktopMsg.LiveAppInfo") }}:</span>
        <el-button type="text" @click="openLiveAppDialog">{{ $t("message.systemMsg.add") }}</el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box" v-if="liveApp.length > 0">
          <el-tag id="tag-box" v-for="(v, i) in liveApp" :key="i">{{
            v.packageName.length > 30
              ? v.packageName.substring(0, 29) + "..."
              : v.packageName
          }}</el-tag>
        </div>
      </el-col>
    </el-row>
    <!-- APP下载 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t('messageAdd.manageApp.001') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle-app">{{ $t('messageAdd.manageApp.002') }}</span>
        <el-button type="text" @click="openAppDownLoadUrl">{{ $t("message.appDesktopMsg.add") }}</el-button>
      </el-col>
      <!-- <el-col :span="10" class="setting-box3">
        <span class="setTitle">{{ $t('messageAdd.manageApp.003') }}</span>
        <el-date-picker v-model="timeValue"
        size="medium"
          type="daterange"
          :range-separator="$t('messageAdd.manageApp.004')"
          :start-placeholder="$t('messageAdd.manageApp.005')"
          :end-placeholder="$t('messageAdd.manageApp.006')"
          @change="handleDateChange"
          value-format="yyyy-MM-dd"
          :clearable="false"
        >
        </el-date-picker>
      </el-col> -->
      <el-col :span="24" v-if="AppOutData.length > 0">
        <el-table :data="AppOutData" border style="margin: 10px;">
          <el-table-column type="index" :label="$t('messageAdd.manageApp.007')" width="50">
          </el-table-column>
          <el-table-column prop="t" :label="$t('messageAdd.manageApp.008')">
            <template slot-scope="scope">
              <span>{{ scope.row.t == 0 ? $t('messageAdd.manageApp.009') : $t('messageAdd.manageApp.010') }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('messageAdd.manageApp.011')">
            <template slot-scope="scope">
              <span>{{ scope.row.t == 0 ? scope.row.du : "***" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="an" :label="$t('messageAdd.manageApp.012')">
          </el-table-column>
          <el-table-column prop="pv" :label="$t('messageAdd.manageApp.013')">
          </el-table-column>
          <el-table-column prop="sd" :label="$t('messageAdd.manageApp.014')">
          </el-table-column>
          <el-table-column prop="v" :label="$t('messageAdd.manageApp.015')">
            <template slot-scope="scope">
              <span>{{ scope.row.v == 0 ? $t('messageAdd.manageApp.016') : $t('messageAdd.manageApp.017') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="e" :label="$t('messageAdd.manageApp.018')">
            <template slot-scope="scope">
              <span v-if="scope.row.e == 0">{{ $t('messageAdd.manageApp.019') }}</span>
              <span v-if="scope.row.e == 1">{{ $t('messageAdd.manageApp.020') }}</span>
              <span v-if="scope.row.e == 2">{{ $t('messageAdd.manageApp.021') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="et" :label="$t('messageAdd.manageApp.022')">
            <template slot-scope="scope">
              <span v-if="scope.row.et == 0">{{ $t('messageAdd.manageApp.023') }}</span>
              <span v-if="scope.row.et == 1">{{ $t('messageAdd.manageApp.024') }}</span>
              <span v-if="scope.row.et == 2">{{ $t('messageAdd.manageApp.025') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="en" :label="$t('messageAdd.manageApp.026')">
          </el-table-column>
          <el-table-column prop="d" :label="$t('messageAdd.manageApp.027')">
            <template slot-scope="scope">
              <span>{{ scope.row.d ? $t('messageAdd.manageApp.028') : $t('messageAdd.manageApp.029') }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('messageAdd.manageApp.030')">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="delAppDownLoad(scope.$index)">{{ $t('messageAdd.manageApp.031') }}</el-button>
              <el-button type="text" size="small" @click="openAppDownLoad(scope.$index, scope.row)">{{ $t('messageAdd.manageApp.032') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- APP卸载 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t('messageAdd.manageApp.033') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle-app">{{ $t('messageAdd.manageApp.034') }}</span>
        <el-button type="text" @click="openDelAppDialog">{{ $t("message.appDesktopMsg.add") }}</el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box" v-if="showDel.length > 0">
          <el-tag id="tag-box" v-for="(v, i) in showDel" :key="i">{{
            v.packageName.length > 30
              ? v.packageName.substring(0, 29) + "..."
              : v.packageName
          }}</el-tag>
        </div>
      </el-col>
    </el-row>
    <!-- App图标隐藏 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t('messageAdd.manageApp.035') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle-app">{{ $t('messageAdd.manageApp.039') }}</span>
        <el-button type="text" @click="openAppIconDialog">{{ $t("message.appDesktopMsg.add") }}</el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box" v-if="showAppIcon.length > 0">
          <el-tag id="tag-box" v-for="(v, i) in showAppIcon" :key="i">{{
            v.packageName.length > 30
              ? v.packageName.substring(0, 29) + "..."
              : v.packageName
          }}</el-tag>
        </div>
      </el-col>
    </el-row>
    <!-- App缓存清理 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t('messageAdd.manageApp.036') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box3">
        <span class="setTitle-app">{{ $t('messageAdd.manageApp.040') }}</span>
        <el-button type="text" @click="openClearCacheDialog">{{ $t("message.appDesktopMsg.add") }}</el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box" v-if="showClear.length > 0">
          <el-tag id="tag-box" v-for="(v, i) in showClear" :key="i">{{
            v.packageName.length > 30
              ? v.packageName.substring(0, 29) + "..."
              : v.packageName
          }}</el-tag>
        </div>
      </el-col>
    </el-row>
    <!-- 黑名单添加弹框 -->
    <el-dialog :title="$t('message.appDesktopMsg.addBlacklistApp')" :visible.sync="blacklistDialogVisible" width="40%">
      <div style="width: 100%">
        <el-button type="text" size="small" icon="el-icon-circle-plus-outline" @click="addblacklist">{{$t("message.appDesktopMsg.add") }}</el-button>
      </div>
      <el-table border :data="bData">
        <el-table-column prop="id" :label="$t('message.appDesktopMsg.index')" width="80" type="index" align="center" />
        <el-table-column prop="packageName" align="center" :label="$t('message.appDesktopMsg.PackageName')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.packageName }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.packageName"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.appDesktopMsg.operation')" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="text" v-show="scope.row.isEdit" @click="okblacklist(scope.row)">{{ $t("message.appDesktopMsg.save") }}</el-button>
            <el-button size="small" type="primary" icon="el-icon-edit" @click="editblackList(scope.row)" v-show="!scope.row.isEdit"></el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" @click="delblacklist(scope.row)" v-show="!scope.row.isEdit"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveblacklist">{{ $t("message.appDesktopMsg.Submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- 不可卸载弹框 -->
    <el-dialog :title="$t('message.appDesktopMsg.uninstallApp')" :visible.sync="uninstallDialogVisible" width="40%">
      <div style="width: 100%">
        <el-button type="text" size="small" icon="el-icon-circle-plus-outline" @click="adduninstall">{{ $t("message.appDesktopMsg.add") }}</el-button>
      </div>
      <el-table border :data="uData">
        <el-table-column prop="id" :label="$t('message.appDesktopMsg.index')" width="80" type="index" align="center" />
        <el-table-column prop="packageName" align="center" :label="$t('message.appDesktopMsg.PackageName')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.packageName }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.packageName"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.appDesktopMsg.operation')" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="text" v-show="scope.row.isEdit" @click="okuninstall(scope.row)">{{ $t("message.appDesktopMsg.save") }}</el-button>
            <el-button size="small" type="primary" icon="el-icon-edit" @click="edituninstall(scope.row)" v-show="!scope.row.isEdit"></el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" @click="deluninstall(scope.row)" v-show="!scope.row.isEdit"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveuninstall">{{ $t("message.appDesktopMsg.Submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- 保活应用 -->
    <el-dialog :title="$t('message.appDesktopMsg.LiveApp')" :visible.sync="liveAppDialogVisible" width="40%">
      <div style="width: 100%">
        <el-button type="text" size="small" icon="el-icon-circle-plus-outline" @click="addliveApp">{{ $t("message.appDesktopMsg.add") }}</el-button>
      </div>
      <el-table border :data="lData">
        <el-table-column prop="id" :label="$t('message.appDesktopMsg.index')" width="80" type="index" align="center" />
        <el-table-column prop="packageName" align="center" :label="$t('message.appDesktopMsg.PackageName')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.packageName }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.packageName"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.appDesktopMsg.operation')" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="text" v-show="scope.row.isEdit" @click="okliveApp(scope.row)">{{ $t("message.appDesktopMsg.save") }}</el-button>
            <el-button size="small" type="primary" icon="el-icon-edit" @click="editliveApp(scope.row)" v-show="!scope.row.isEdit"></el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" @click="delliveApp(scope.row)" v-show="!scope.row.isEdit"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveliveApp">{{ $t("message.appDesktopMsg.Submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- app卸载 -->
    <el-dialog :title="$t('messageAdd.manageApp.038')" :visible.sync="appDelDialogVisible" width="40%">
      <div style="width: 100%">
        <el-button type="text" size="small" icon="el-icon-circle-plus-outline" @click="addDelApp">{{ $t("message.appDesktopMsg.add") }}</el-button>
      </div>
      <el-table border :data="delAppData">
        <el-table-column prop="id" :label="$t('message.appDesktopMsg.index')" width="80" type="index" align="center" />
        <el-table-column prop="packageName" align="center" :label="$t('message.appDesktopMsg.PackageName')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.packageName }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.packageName"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.appDesktopMsg.operation')" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="text" v-show="scope.row.isEdit" @click="okDelApp(scope.row)">{{ $t("message.appDesktopMsg.save") }}</el-button>
            <el-button size="small" type="primary" icon="el-icon-edit" @click="editDelApp(scope.row)" v-show="!scope.row.isEdit"></el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" @click="delDelApp(scope.row)" v-show="!scope.row.isEdit"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveDelApp">{{ $t("message.appDesktopMsg.Submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- app图标隐藏 -->
    <el-dialog :title="$t('messageAdd.manageApp.039')" :visible.sync="appIconDialogVisible" width="40%">
      <div style="width: 100%">
        <el-button type="text" size="small" icon="el-icon-circle-plus-outline" @click="addAppIcon">{{ $t("message.appDesktopMsg.add") }}</el-button>
      </div>
      <el-table border :data="appIconData">
        <el-table-column prop="id" :label="$t('message.appDesktopMsg.index')" width="80" type="index" align="center" />
        <el-table-column prop="packageName" align="center" :label="$t('message.appDesktopMsg.PackageName')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.packageName }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.packageName"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.appDesktopMsg.operation')" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="text" v-show="scope.row.isEdit" @click="okAppIcon(scope.row)">{{ $t("message.appDesktopMsg.save") }}</el-button>
            <el-button size="small" type="primary" icon="el-icon-edit" @click="editAppIcon(scope.row)" v-show="!scope.row.isEdit"></el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" @click="delAppIcon(scope.row)" v-show="!scope.row.isEdit"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveAppIcon">{{ $t("message.appDesktopMsg.Submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- App缓存清理 -->
    <el-dialog :title="$t('messageAdd.manageApp.040')" :visible.sync="clearCacheDialogVisible" width="40%">
      <div style="width: 100%">
        <el-button type="text" size="small" icon="el-icon-circle-plus-outline" @click="addClearCache">{{  $t("message.appDesktopMsg.add") }}</el-button>
      </div>
      <el-table border :data="clearCacheData">
        <el-table-column prop="id" :label="$t('message.appDesktopMsg.index')" width="80" type="index" align="center" />
        <el-table-column prop="packageName" align="center" :label="$t('message.appDesktopMsg.PackageName')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.packageName }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.packageName"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.appDesktopMsg.operation')" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="text" v-show="scope.row.isEdit" @click="okClearCache(scope.row)">{{ $t("message.appDesktopMsg.save") }}</el-button>
            <el-button size="small" type="primary" icon="el-icon-edit" @click="editClearCache(scope.row)" v-show="!scope.row.isEdit"></el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" @click="delClearCache(scope.row)" v-show="!scope.row.isEdit"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveClearCache">{{ $t("message.appDesktopMsg.Submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- app下载路径 -->
    <el-dialog :title="$t('messageAdd.manageApp.041')" :visible.sync="outUrlDialogVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" @close="handleOutUrlClose" width="60%">
      <div v-show="downUrlData.t === 1" style="color:red;">{{ $t('messageAdd.manageApp.065') }}</div>
      <el-form ref="downUrlRuleForm" label-width="150px" :model="downUrlData" :rules="downUrlRules"
        class="download-box">
        <el-form-item :label="$t('messageAdd.manageApp.064')" prop="t">
          <el-radio-group v-model="downUrlData.t" @input="handleAppRadioChange">
            <el-radio :label="0">{{ $t('messageAdd.manageApp.009') }}</el-radio>
            <el-radio :label="1">{{ $t('messageAdd.manageApp.010') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageApp.043')" v-show="downUrlData.t === 1">
          <el-upload class="upload-demo" ref="upload" action="#" :limit="1" accept=".apk" :on-change="handleChange"
            :on-remove="handleRemove" :file-list="fileList" :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">{{ $t('messageAdd.manageApp.044') }}</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">{{ $t('messageAdd.manageApp.045') }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageApp.041')" v-show="downUrlData.t === 0">
          <el-input v-model="downUrlData.du"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageApp.046')" prop="an">
          <el-input v-model="downUrlData.an"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageApp.047')" prop="pv">
          <el-input v-model="downUrlData.pv"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageApp.014')">
          <el-input v-model="downUrlData.sd"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageApp.015')">
          <el-select v-model="downUrlData.v">
            <el-option :label="$t('messageAdd.manageApp.016')" :value="0"></el-option>
            <el-option :label="$t('messageAdd.manageApp.017')" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageApp.018')">
          <el-select v-model="downUrlData.e">
            <el-option :label="$t('messageAdd.manageApp.019')" :value="0"></el-option>
            <el-option :label="$t('messageAdd.manageApp.020')" :value="1"></el-option>
            <el-option :label="$t('messageAdd.manageApp.021')" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageApp.022')" v-show="downUrlData.e === 0">
          <el-select v-model="downUrlData.et">
            <el-option :label="$t('messageAdd.manageApp.023')" :value="0"></el-option>
            <el-option :label="$t('messageAdd.manageApp.024')" :value="1"></el-option>
            <el-option :label="$t('messageAdd.manageApp.025')" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageApp.026')" v-show="downUrlData.et === 1 || downUrlData.et === 2">
          <el-input v-model="downUrlData.en"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.manageApp.027')">
          <el-select v-model="downUrlData.d" @change="handleIsStart">
            <el-option :label="$t('messageAdd.manageApp.028')" :value="true"></el-option>
            <el-option :label="$t('messageAdd.manageApp.029')" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveDownUrlData">{{ $t("message.appDesktopMsg.Submit") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { uploadFile } from "@/api/stage";
import { EventBus } from '@/utils/event-bus';
export default {
  data() {
    return {
      blacklist: [],
      uninstall: [],
      liveApp: [],
      blacklistDialogVisible: false,
      uninstallDialogVisible: false,
      liveAppDialogVisible: false,
      // app
      appDelDialogVisible: false,
      appIconDialogVisible: false,
      clearCacheDialogVisible: false,
      outUrlDialogVisible: false,
      // app桌面
      desktopData: {},
      bData: [],
      uData: [],
      lData: [],
      AppOutData: [],
      AppRadio: null,
      // app卸载
      delAppData: [],
      showDel: [],
      appIconData: [],
      showAppIcon: [],
      clearCacheData: [],
      showClear: [],
      fileList: [],
      ma: {
        da: [],
        t: ""
      },
      // 下载路径表单数据
      downUrlData: {
        t: 0,
        v: 1,
        sd: "/sdcard/StageNow",
        e: 1,
        et: null,
        d: false,
        an: "",
        pv: '',
        en: ''
      },
      // 时间数据
      timeValue: [],
      mode: '',
      selectIndex: 0,
    };
  },
  computed: {
    // 表单校验
    downUrlRules() {
      return {
        t: [
          { required: true, message: this.$t('messageAdd.manageApp.050'), trigger: 'change' }
        ],
        sd: [
          { required: true, message: this.$t('messageAdd.manageApp.051'), trigger: 'blur' }
        ],
        an: [
          { required: true, message: this.$t('messageAdd.manageApp.052'), trigger: 'blur' }
        ],
        pv: [
          { required: true, message: this.$t('messageAdd.manageApp.053'), trigger: 'blur' }
        ]
      }
    },
  },
  methods: {
    // 通用弹窗方法
    openDialogWithData(dialogVisibleProp, localStorageKey, dataProp, splitKey) {
      // 设置弹框的可见性
      this[dialogVisibleProp] = true; // 打开弹框
      // 从 localStorage 获取数据
      if (localStorage.getItem(localStorageKey)) {
        const localStorageData = localStorage.getItem(localStorageKey);
        if (localStorageData) {
          // 解析 JSON 数据
          const parsedData = JSON.parse(localStorageData);
          // 获取字符串数据
          const stringData = parsedData[splitKey];
          // 如果存在字符串数据，则进行分割并处理
          if (stringData) {
            // 初始化数据数组
            this[dataProp] = [];
            // 使用 split 方法按逗号分割字符串
            const items = stringData.split(',');
            // 遍历每个项目，并添加到数组中
            items.forEach(item => {
              // 去除可能的空白字符
              const trimmedItem = item.trim();
              // 将项目添加到数组中，假设只有 packageName 字段，但可以根据需要添加其他字段
              this[dataProp].push({ packageName: trimmedItem, isEdit: false });
            });
          }
        }
      }
    },
    // 通用提交方法
    saveDataToLocalStorage(storageKey, targetProp, dataArray, dialogVisibleProp) {
      // 读取 localStorage 中的数据（如果有）
      let storageData = localStorage.getItem(storageKey);
      if (storageData) {
        // 解析为对象
        this[dialogVisibleProp.substring(0, dialogVisibleProp.length - 9)] = JSON.parse(storageData);
      } else {
        // 如果数据不存在，则创建一个空对象
        this[dialogVisibleProp.substring(0, dialogVisibleProp.length - 9)] = {};
      }
      // 获取存储对象（假设它与我们想要更新的属性在同一个对象中）
      let dataObject = this[dialogVisibleProp.substring(0, dialogVisibleProp.length - 9)];
      // 更新对象的属性
      dataObject[targetProp] = dataArray.map(item => item.packageName).join(',');
      // 关闭相关的对话框
      this[dialogVisibleProp] = false;
      // 将更新后的对象保存回 localStorage
      localStorage.setItem(storageKey, JSON.stringify(dataObject));
    },

    // ====================================黑名单===================================
    openBlackDialog() {
      this.openDialogWithData('blacklistDialogVisible', 'ma', 'bData', 'b');
    },
    addblacklist() {
      this.bData.push({ packageName: '', isEdit: true })
    },
    editblackList(data) {
      data.isEdit = true;
    },
    okblacklist(data) {
      if (data.packageName != "") {
        this.ma.b = this.bData.map(i => i.packageName).join(',');
        data.isEdit = false;
      } else {
        this.$message({
          message: this.$t("message.messageMsg.pnNoEmpty"),
          type: "warning",
        });
      }
    },
    delblacklist(data) {
      const index = this.bData.indexOf(data);
      if (index !== -1) {
        this.bData.splice(index, 1);
      }
    },
    saveblacklist() {
      // 检查wData数组中的每个fileUrl值是否不为空
      const isEmptyFileUrl = this.bData.some(item => !item.packageName);
      if (isEmptyFileUrl) {
        this.$message.error(this.$t('messageAdd.manageApp.066'));
        return;
      }
      this.saveDataToLocalStorage('ma', 'b', this.bData, 'blacklistDialogVisible');
      this.blacklist = [...this.bData];
    },
    // =========================不可卸载=================================
    openUninstallDialog() {
      this.openDialogWithData('uninstallDialogVisible', 'ma', 'uData', 'd');
    },
    adduninstall() {
      this.uData.push({ packageName: '', isEdit: true })
    },
    edituninstall(data) {
      data.isEdit = true;
    },
    okuninstall(data) {
      if (data.packageName != "") {
        this.ma.d = this.uData.map(i => i.packageName).join(',');
        data.isEdit = false;
      } else {
        this.$message({
          message: this.$t("message.messageMsg.pnNoEmpty"),
          type: "warning",
        });
      }
    },
    deluninstall(data) {
      const index = this.uData.indexOf(data);
      if (index !== -1) {
        this.uData.splice(index, 1);
      }
    },
    saveuninstall() {
      // 检查wData数组中的每个fileUrl值是否不为空
      const isEmptyFileUrl = this.uData.some(item => !item.packageName);
      if (isEmptyFileUrl) {
        this.$message.error(this.$t('messageAdd.manageApp.066'));
        return;
      }
      this.saveDataToLocalStorage('ma', 'd', this.uData, 'uninstallDialogVisible');
      this.uninstall = [...this.uData];
    },
    // ==============================保活应用============================
    openLiveAppDialog() {
      this.openDialogWithData('liveAppDialogVisible', 'ma', 'lData', 'k');
    },
    addliveApp() {
      this.lData.push({ packageName: "", isEdit: true });
    },
    editliveApp(data) {
      data.isEdit = true;
    },
    okliveApp(data) {
      if (data.packageName != "") {
        this.ma.k = this.lData.map(i => i.packageName).join(',');
        data.isEdit = false;
      } else {
        this.$message({
          message: this.$t("message.messageMsg.pnNoEmpty"),
          type: "warning",
        });
      }
    },
    delliveApp(data) {
      const index = this.lData.indexOf(data);
      if (index !== -1) {
        this.lData.splice(index, 1);
      }
    },
    saveliveApp() {
      // 检查wData数组中的每个fileUrl值是否不为空
      const isEmptyFileUrl = this.lData.some(item => !item.packageName);
      if (isEmptyFileUrl) {
        this.$message.error(this.$t('messageAdd.manageApp.066'));
        return;
      }
      this.saveDataToLocalStorage('ma', 'k', this.lData, 'liveAppDialogVisible');
      this.liveApp = [...this.lData];
    },
    // =================================APP卸载========================
    openDelAppDialog() {
      this.openDialogWithData('appDelDialogVisible', 'ma', 'delAppData', 'u');
    },
    addDelApp() {
      this.delAppData.push({ packageName: '', isEdit: true })
    },
    editDelApp(data) {
      data.isEdit = true;
    },
    okDelApp(data) {
      if (data.packageName != "") {
        this.ma.u = this.delAppData.map(i => i.packageName).join(',');
        data.isEdit = false;
      } else {
        this.$message({
          message: this.$t("message.messageMsg.pnNoEmpty"),
          type: "warning",
        });
      }
    },
    delDelApp(data) {
      const index = this.delAppData.indexOf(data);
      if (index !== -1) {
        this.delAppData.splice(index, 1);
      }
    },
    saveDelApp() {
      // 检查wData数组中的每个fileUrl值是否不为空
      const isEmptyFileUrl = this.delAppData.some(item => !item.packageName);
      if (isEmptyFileUrl) {
        this.$message.error(this.$t('messageAdd.manageApp.066'));
        return;
      }
      this.saveDataToLocalStorage('ma', 'u', this.delAppData, 'appDelDialogVisible');
      this.showDel = [...this.delAppData];
    },
    // ============================App图标隐藏============================
    openAppIconDialog() {
      this.openDialogWithData('appIconDialogVisible', 'ma', 'appIconData', 'h');
    },
    addAppIcon() {
      this.appIconData.push({ packageName: '', isEdit: true })
    },
    editAppIcon(data) {
      data.isEdit = true;
    },
    okAppIcon(data) {
      if (data.packageName != "") {
        this.ma.h = this.appIconData.map(i => i.packageName).join(',');
        data.isEdit = false;
      } else {
        this.$message({
          message: this.$t("message.messageMsg.pnNoEmpty"),
          type: "warning",
        });
      }
    },
    delAppIcon(data) {
      const index = this.appIconData.indexOf(data);
      if (index !== -1) {
        this.appIconData.splice(index, 1);
      }
    },
    saveAppIcon() {
      // 检查wData数组中的每个fileUrl值是否不为空
      const isEmptyFileUrl = this.appIconData.some(item => !item.packageName);
      if (isEmptyFileUrl) {
        this.$message.error(this.$t('messageAdd.manageApp.066'));
        return;
      }
      this.saveDataToLocalStorage('ma', 'h', this.appIconData, 'appIconDialogVisible');
      this.showAppIcon = [...this.appIconData];
    },
    // =========================App缓存清理========================================
    openClearCacheDialog() {
      this.openDialogWithData('clearCacheDialogVisible', 'ma', 'clearCacheData', 'c');
    },
    addClearCache() {
      this.clearCacheData.push({ packageName: '', isEdit: true })
    },
    editClearCache(data) {
      data.isEdit = true;
    },
    okClearCache(data) {
      if (data.packageName != "") {
        this.ma.c = this.clearCacheData.map(i => i.packageName).join(',');
        data.isEdit = false;
      } else {
        this.$message({
          message: this.$t("message.messageMsg.pnNoEmpty"),
          type: "warning",
        });
      }
    },
    delClearCache(data) {
      const index = this.clearCacheData.indexOf(data);
      if (index !== -1) {
        this.clearCacheData.splice(index, 1);
      }
    },
    saveClearCache() {
      // 检查wData数组中的每个fileUrl值是否不为空
      const isEmptyFileUrl = this.clearCacheData.some(item => !item.packageName);
      if (isEmptyFileUrl) {
        this.$message.error(this.$t('messageAdd.manageApp.066'));
        return;
      }
      this.saveDataToLocalStorage('ma', 'c', this.clearCacheData, 'clearCacheDialogVisible');
      this.showClear = [...this.clearCacheData];
    },
    // ==========================App应用下载外部地址===============================
    // 打开管理文件弹框
    openAppDownLoadUrl() {
      this.outUrlDialogVisible = true;
      this.mode = 'add';
    },
    // 时间分割
    // handleDateChange(value) {
    //   // 当日期范围变化时触发
    //   if (value && value.length === 2) {
    //     // 使用 &#126; 连接开始日期和结束日期
    //     this.ma.t = `${value[0]}~${value[1]}`;
    //   } else {
    //     this.ma.t = "";
    //   }
    //   // 保存至方案
    //   let maData=localStorage.getItem("ma");
    //   if(maData){
    //     this.ma=JSON.parse(maData);
    //   }
    //   localStorage.setItem("ma",JSON.stringify(this.ma));
    // },
    // 选择服务器类型
    handleAppRadioChange(val) {
      this.downUrlData = {
        t: val,
        v: 1,
        sd: "/sdcard/StageNow",
        e: 1,
        et: null,
        d: false,
        an: "",
        pv: '',
        en: ""
      };
      this.fileList = [];

    },
    // 上传文件
    handleChange(file, fileList) {
      if (file) {
        this.downUrlData.an = file.name.split('.')[0];
      }
      this.fileList = fileList;
    },
    handleRemove() {
      this.downUrlData.an = '';
    },
    submitUpload() {
      const maxSize = 200 * 1024 * 1024;
      const count = this.AppOutData.reduce((acc, item) => item.t === 1 ? acc + 1 : acc, 0);
      if (this.fileList[0].size > maxSize) {
        this.$message.error(this.$t('messageAdd.manageCert.063'));
        this.fileList = [];
        this.downUrlData.an = '';
        return; // 停止进一步处理
      } else if (count >= 10) {
        this.$message.error(this.$t('messageAdd.manageCert.060'));
        this.fileList = [];
        this.downUrlData.an = '';
        this.outUrlDialogVisible = false;
        return;
      }
      else {
        // 调用uploadFile接口使用formData上传文件
        let formData = new FormData();
        if (this.fileList.length > 0) {
          formData.append('fileList', this.fileList[0].raw); // 注意这里使用了 fileList[]
        }
        formData.append('type', 1);
        const loading = this.$loading({
          lock: true,
          text: this.$t('messageAdd.manageApp.054'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        uploadFile(formData, 1).then(res => {
          if (res.success) {
            loading.close();
            this.downUrlData.id = res.data[0].id;
            this.downUrlData.md5 = res.data[0].md5;
            // 后期URL需要加密
            this.downUrlData.du = res.data[0].url;
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.manageApp.055'));
          } else {
            loading.close();
            this.$message.closeAll();
            this.$message.error(this.$t(`code.${res.errorCode}`) + res.errorInfo ? res.errorInfo : '');
          }
        })
      }
    },
    // 处理启动项
    handleIsStart() {
      let isDAlreadyTrue = false;
      for (let item of this.AppOutData) {
        if (item.d) {
          isDAlreadyTrue = true;
          break;
        }
      }
      if (isDAlreadyTrue) {
        // 如果当前downUrlData的d也是true，则提示用户
        if (this.downUrlData.d) {
          this.$confirm(this.$t('messageAdd.manageApp.056'), this.$t('messageAdd.manageApp.057'), {
            confirmButtonText: this.$t('messageAdd.manageApp.058'),
            cancelButtonText: this.$t('messageAdd.manageApp.059'),
            type: 'warning'
          }).then(() => {
            this.clearOtherDTrue();
          }).catch(() => {
            this.downUrlData.d = false;
          });
        }
      }
    },
    saveDownUrlData() {
      if (this.downUrlData.t === 1 && this.downUrlData.id === undefined) {
        this.$message.error(this.$t('messageAdd.manageApp.060'));
        return;
      }
      this.$refs["downUrlRuleForm"].validate((valid) => {
        if (valid) {
          if (this.mode === "add") {
            if (this.downUrlData.et == 1 || this.downUrlData.et == 2) {
              this.downUrlData.en = 'com.seuic.demo.MainActivity';
            }
            this.AppOutData.push(this.downUrlData);
            this.outUrlDialogVisible = false;
            this.fileList = [];
            this.$refs["downUrlRuleForm"].clearValidate();
            this.downUrlData = {
              t: 0,
              v: 1,
              sd: "/sdcard/StageNow",
              e: 1,
              et: 0,
              d: false,
              an: "",
              pv: ''
            }
          } else if (this.mode === "update") {
            if (this.downUrlData.et == 1 || this.downUrlData.et == 2) {
              this.downUrlData.en = 'com.seuic.demo.MainActivity';
            }
            this.AppOutData.splice(this.selectIndex, 1, this.downUrlData);
            this.outUrlDialogVisible = false;
            this.fileList = [];
            this.$refs["downUrlRuleForm"].clearValidate();
            this.downUrlData = {
              t: 0,
              v: 1,
              sd: "/sdcard/StageNow",
              e: 1,
              et: 0,
              d: false,
              an: "",
              pv: ''
            }
          }
        }
      })
      // 读取 localStorage 中的 ma 数据（如果有）
      let maData = localStorage.getItem("ma");
      if (maData) {
        this.ma = JSON.parse(maData); // 解析为对象
      }
      // 更新 mf 数据
      this.ma.da = [...this.AppOutData];
      localStorage.setItem("ma", JSON.stringify(this.ma));
    },
    handleOutUrlClose() {
      this.outUrlDialogVisible = false;
      this.fileList = [];
      this.$refs["downUrlRuleForm"].clearValidate();
      this.downUrlData = {
        t: 0,
        v: 1,
        sd: "/sdcard/StageNow",
        e: 1,
        et: null,
        d: false,
        an: "",
        b: '',
        en: ''
      }
    },
    // 删除表格数据
    delAppDownLoad(index) {
      this.$confirm(this.$t('messageAdd.manageApp.061'), this.$t('messageAdd.manageApp.057'), {
        confirmButtonText: this.$t('messageAdd.manageApp.058'),
        cancelButtonText: this.$t('messageAdd.manageApp.059'),
        type: 'warning'
      }).then(() => {
        this.AppOutData.splice(index, 1);
        // 读取 localStorage 中的 ma 数据（如果有）
        let maData = localStorage.getItem("ma");
        if (maData) {
          this.ma = JSON.parse(maData); // 解析为对象
        }
        // 更新 mf 数据
        this.ma.da = [...this.AppOutData];
        localStorage.setItem("ma", JSON.stringify(this.ma));
        this.$message({
          type: 'success',
          message: this.$t('messageAdd.manageApp.062')
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('messageAdd.manageApp.063')
        });
      });
    },
    // 打开编辑菜单
    openAppDownLoad(index, data) {
      this.mode = 'update';
      this.downUrlData = { ...data };
      this.outUrlDialogVisible = true;
      this.selectIndex = index;
    },
    // 假设的辅助方法，用于清理其他d为true的项
    clearOtherDTrue() {
      for (let i = 0; i < this.AppOutData.length; i++) {
        if (this.AppOutData[i] !== this.downUrlData && this.AppOutData[i].d) {
          this.AppOutData[i].d = false;
        }
      }
    },
  },
  created() {
    EventBus.$on('clearMAdata', () => {
      // 清空当前页面的数据
      this.blacklist = []
      this.uninstall = []
      this.liveApp = []
      this.desktopData = {}
      this.bData = []
      this.uData = []
      this.lData = []
      this.AppOutData = []
      this.AppRadio = null
      // app卸载
      this.delAppData = []
      this.showDel = []
      this.appIconData = []
      this.showAppIcon = []
      this.clearCacheData = []
      this.showClear = []
      this.fileList = []
      this.ma = {
        da: [],
        t: ""
      }
      // this.timeValue=[]
      this.mode = ''
      this.selectIndex = 0
    })

    // 回显已保存数据
    const data = JSON.parse(localStorage.getItem('ma'));

    if (data) {
      if (data.da) {
        if (data.da.length > 0) {
          this.AppOutData = JSON.parse(JSON.stringify(data.da));
        }
      }
      if (data.b) {
        let resArr = data.b.split(',');
        resArr.map(i => {
          this.blacklist.push({ packageName: i });
        })
      }
      if (data.c) {
        let resArr = data.c.split(',');
        resArr.map(i => {
          this.showClear.push({ packageName: i });
        })
      }
      if (data.d) {
        let resArr = data.d.split(',');
        resArr.map(i => {
          this.uninstall.push({ packageName: i });
        })
      }
      if (data.h) {
        let resArr = data.h.split(',');
        resArr.map(i => {
          this.showAppIcon.push({ packageName: i });
        })
      }
      if (data.k) {
        let resArr = data.h.split(',');
        resArr.map(i => {
          this.liveApp.push({ packageName: i });
        })
      }
      if (data.u) {
        let resArr = data.h.split(',');
        resArr.map(i => {
          this.showDel.push({ packageName: i });
        })
      }
    }
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器，避免内存泄漏
    EventBus.$off('clearMFdata');
  }
};
</script>
